const pagesForSuperAdmin = [
  '/organisations',
  '/users',
  '/email-trigger',
  '/business-rules',
  '/custom-business-rules',
  '/reach-parameter',
  '/data-management/markets',
  '/data-management/networks',
  '/data-management/stations',
  '/data-management/demographics',
];

const pagesForOrganisationalAdmin = [
  '/campaigns',
  '/campaigns/archived',
  '/avails',
  '/avails/inventories',
  '/avails/inventories/archived',
  '/markets',
  '/users',
  '/programme',
  '/data-management/clients',
  '/data-management/markets',
  '/data-management/stations',
  '/data-management/demographics',
  '/agency-commission',
  '/bookings',
  '/contacts',
  '/trafficking/creatives',
  '/trafficking/instructions',
  '/orders',
  '/orders-without-invoice',
  '/orders-without-traffic',
  '/orders-version-history',
  '/invoices',
  '/invoices/without-order',
];

const pagesForOrganisationalUser = [
  '/campaigns',
  '/campaigns/archived',
  '/avails',
  '/avails/inventories',
  '/avails/inventories/archived',
  '/markets',
  '/programme',
  '/bookings',
  '/contacts',
  '/trafficking/creatives',
  '/trafficking/instructions',
  '/orders',
  '/orders-without-invoice',
  '/orders-without-traffic',
  '/orders-version-history',
  '/invoices',
  '/invoices/without-order',
];

const commonPages = [
  '/profile',
  '/ows',
  '/maintenance',
  '/request-timeout',
  '/access-denied',
  '/maintenance',
  '/internal-server',
];

const allPages = new Set([
  ...pagesForSuperAdmin,
  ...pagesForOrganisationalAdmin,
  ...pagesForOrganisationalUser,
  ...commonPages,
]);

const RouterService = {
  isAccessibleForSuperAdmin(pathname) {
    const accessiblePages = [...pagesForSuperAdmin, ...commonPages];
    return (
      accessiblePages.includes(pathname)
      || (/\d/.test(pathname)
        && accessiblePages.some((path) => pathname.includes(path)))
    );
  },

  isAccessibleForOrganisationalAdmin(pathname) {
    const accessiblePages = [...pagesForOrganisationalAdmin, ...commonPages];
    return (
      accessiblePages.includes(pathname)
      || (/\d/.test(pathname)
        && accessiblePages.some((path) => pathname.includes(path)))
    );
  },

  isAccessibleForOrganisationalUser(pathname) {
    const accessiblePages = [...pagesForOrganisationalUser, ...commonPages];
    return (
      accessiblePages.includes(pathname)
      || (/\d/.test(pathname)
        && accessiblePages.some((path) => pathname.includes(path)))
    );
  },

  isValidUrl(pathname) {
    return (
      [...allPages].includes(pathname)
      || [...allPages].some((path) => pathname.includes(path))
    );
  },
};

export default RouterService;
